export const iframeSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const iframeSectionTitleStyles = {
  paddingBottom: '4px',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const getIframeFrameStyles = ({ heightInPx }) => ({
  display: 'flex',
  width: '100%',
  height: `${heightInPx}px`,
});

export const iframeStyles = {
  border: 0,
  display: 'block',
  width: '100%',
  height: '100%',
};

export const iframeMissingUrlStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '24px',
  borderRadius: '6px',
  border: '1px dashed',
  borderColor: 'divider',
  backgroundColor: 'action.hover',
};
